import { React, useState, useEffect, useContext } from "react";
import UserContext from "../../../components/User_Context.js";
import { useNavigate, Navigate, useParams } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import * as api from "../../../api/apiConnector.js";
import { useTranslation, initReactI18next } from "react-i18next";
import * as menu from "../../../assets/menus/menu.js";

// Initialize i18n and register login labels at module scope so they are
// available on the very first render (login is the first screen, menu.write()
// has not been called yet so i18n is not initialized at this point).
const _i18n = menu.getI18n();
const _language = localStorage.getItem("language") || process.env.REACT_APP_LANGUAGE || "it";
if (!_i18n.isInitialized) {
  _i18n.use(initReactI18next).init({ lng: _language, resources: {} });
}
_i18n.addResourceBundle('it', 'labels', {
  username: 'Username',
  password: 'Password',
  usernamePlaceholder: 'Inserisci il tuo username',
  passwordPlaceholder: 'Inserisci la tua password',
  loginButton: 'Log In',
  orContinueWith: 'O continua con',
  loginWithOAuth: 'Login with OAuth',
  logInTitle: 'Log In',
  loginDescription: 'Loggati per accedere alla piattaforma AI PLAN IPC',
  aiPlanTitle: 'AI PLAN IPC',
  aiPlanDescription: 'AI PLAN IPC è una piattaforma modulare per digitalizzare qualità, rischio clinico e conformità nelle strutture sanitarie. Automatizza flussi, raccoglie dati strutturati e garantisce tracciabilità e conformità normativa.',
  copyright: 'by',
  error: 'Errore',
  somethingWentWrong: 'Qualcosa è andato storto!!',
  passwordExpired: 'Password scaduta!!',
  yourEmailIsNotAllowedToEnterWithGoogle: 'Il tuo indirizzo email non è autorizzato a entrare con Google',
  oops: 'OOOPSS!!',
  thereWasSomeProblemsDuringTheGoogleLogin: 'Ci sono stati problemi durante l\'accesso con Google',
  UserNotFound: "Utente multiplo o non trovato",
  UserAccountDisabled: "Utente disabillitato",
  WrongOAuth: "Il tipo di autenticazione con cui stai provando ad accedere non è corretto",
  WrongPassword: "Email e/o password non corretta"
}, true, true);
_i18n.addResourceBundle('en', 'labels', {
  username: 'Username',
  password: 'Password',
  usernamePlaceholder: 'Enter your username',
  passwordPlaceholder: 'Enter your password',
  loginButton: 'Log In',
  orContinueWith: 'Or continue with',
  loginWithOAuth: 'Login with OAuth',
  logInTitle: 'Log In',
  loginDescription: 'Log in to access the AI PLAN IPC platform',
  aiPlanTitle: 'AI PLAN IPC',
  aiPlanDescription: 'AI PLAN IPC is a modular platform for digitizing quality, clinical risk and compliance in healthcare facilities. It automates processes, collects structured data and ensures traceability and regulatory compliance.',
  copyright: 'by',
  error: 'Error',
  somethingWentWrong: 'Something went wrong!!',
  passwordExpired: 'Password expired!!',
  yourEmailIsNotAllowedToEnterWithGoogle: 'Your email is not allowed to enter with Google',
  oops: 'OOOPSS!!',
  thereWasSomeProblemsDuringTheGoogleLogin: 'There was some problems during the Google Login',
  UserNotFound: "Multiple user or not found",
  UserAccountDisabled: "Unabled user",
  WrongOAuth: "Authentication method is wrong",
  WrongPassword: "Email and/or password is wrong"
}, true, true);

function Login_Darm_Screen(params) {
  const {local} =useParams();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [oauthUrl, setOauthUrl] = useState(null);
  const [titleName, setTitleName] = useState(process.env.REACT_APP_TITLE_NAME);
  const { doLogon, doGoogleLogon, createOAuthUrl } = useContext(UserContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  let oAuthGoogle = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;


  const logon = async () => {
    setIsLoading(true);
    const result = await doLogon({ userName, password });

    if (!result?.success) {
      setIsLoading(false);
      // networkError: il dialog è già stato mostrato da apiConnector
      if (!result?.networkError) {
        const message =
          result?.message
            ? t(`${result.message}`, { ns: 'labels' })
            : t('somethingWentWrong', { ns: 'labels' });
        await withReactContent(Swal).fire({
          title: t('error', { ns: 'labels' }),
          icon: "info",
          text: message,
          allowOutsideClick: true,
        });
      }
      return;
    }

    
    if(result.passwordExpired){
      window.document.location.href = "/changePassword";
      return;
    }

    const isLoginPage = window.document.location.href
      .toLowerCase()
      .includes("/login");

    if (isLoginPage) {
      window.document.location.href = "/";
    } else {
      window.document.location.reload();
    }

    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const configResult = await api.sendMessage("darm/configurations/get_public", {});
        if (configResult?.data?.installationName) {
          setTitleName(configResult.data.installationName);
        }
      } catch (err) {
        console.error("Error loading public config:", err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const oauthUrlResult = await createOAuthUrl();

        if (oauthUrlResult && oauthUrlResult.success && oauthUrlResult.url) {
          setOauthUrl(oauthUrlResult.url);
        }

        if (oauthUrlResult.url && local != 'local') {
          window.location.href = oauthUrlResult.url
        }

      } catch (error) {
        console.log("Error creating OAuth URL:", error);
      }

      window.$(".deznav").hide();
      window.$(".content-body").removeClass("content-body");
      window.$("#main-wrapper").addClass("menu-toggle");
      window.$(".hamburger").parent().hide();
      window.$(".header-content").hide();
      window.$(".nav-header").hide();
      window.$(".page-titles").hide();
      window.$(".header").hide();
    })();
  }, [createOAuthUrl, local]);

  //#region google login
  const responseMessageGoogle = async (response) => {
    // console.log(response.credential);

    var googleLogonMethod = await doGoogleLogon(response);

    if (googleLogonMethod.success) {
      if (window.document.location.href.toLowerCase().includes("/login")) {
        window.document.location.href = "/";
      } else {
        window.document.location.reload();
      }
    } else {
      withReactContent(Swal).fire({
        title: t('error', { ns: 'labels' }),
        icon: "info",
        text: t('yourEmailIsNotAllowedToEnterWithGoogle', { ns: 'labels' }),
        allowOutsideClick: true,
      });
    }
  };

  function errorMessageGoogle(response) {
    var errorResponse = response;

    withReactContent(Swal).fire({
      title: t('oops', { ns: 'labels' }),
      icon: "info",
      text: t('thereWasSomeProblemsDuringTheGoogleLogin', { ns: 'labels' }),
      allowOutsideClick: false,
    });
  }

  //#endregion

  return (
    <GoogleOAuthProvider clientId={oAuthGoogle}>
      <div className="container-fluid vh-100">
        <div className="row h-100">
          <div className="col-lg-6 col-md-12 col-sm-12 mx-auto align-self-center">
            <div className="login-form">
              <div className="text-center">
                <h3 className="title">{t('logInTitle', { ns: 'labels' })}</h3>
                <p>{t('loginDescription', { ns: 'labels' })}</p>
              </div>
              <div className="mb-4">
                <label htmlFor="username-input" className="mb-1 text-dark fw-bold">
                  {t('username', { ns: 'labels' })}
                </label>
                <input
                  id="username-input"
                  type="text"
                  className="form-control form-control"
                  value={userName}
                  placeholder={t('usernamePlaceholder', { ns: 'labels' })}
                  onChange={(e) => {
                    setUserName(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      return logon();
                    }
                  }}
                />
              </div>
              <div className="mb-4 position-relative">
                <label htmlFor="dz-password" className="mb-1 text-dark fw-bold">
                  {t('password', { ns: 'labels' })}
                </label>
                <input
                  type="password"
                  id="dz-password"
                  className="form-control"
                  value={password}
                  placeholder={t('passwordPlaceholder', { ns: 'labels' })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      return logon();
                    }
                  }}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <span className="show-pass eye">
                  <i className="fa fa-eye-slash"></i>
                  <i className="fa fa-eye"></i>
                </span>
              </div>
              {/* <div className="form-row d-flex justify-content-between mt-4 mb-2">
                                <div className="mb-4">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input type="checkbox" className="form-check-input" id="customCheckBox1" required="" />
                                        <label className="form-check-label" for="customCheckBox1">Remember my preference</label>
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <a href="page-forgot-password.html" className="btn-link text-primary">Forgot Password?</a>
                                </div>
                            </div> */}
              <div className="text-center mb-4">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={logon}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    t('loginButton', { ns: 'labels' })
                  )}
                </button>
              </div>
              
                {oauthUrl ? (
                  <>
                  <h6 className="login-title">
                  <span>{t('orContinueWith', { ns: 'labels' })}</span>
                </h6>
                <div className="text-center mb-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={() => document.location.href = oauthUrl}
                    disabled={isLoading}
                    title="Login with OAuth"
                  >
                    {isLoading ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : (
                      <>
                        <i className="fas fa-key me-2"></i>
                        {t('loginWithOAuth', { ns: 'labels' })}
                      </>
                    )}
                  </button>
                  </div>
                  </>
                ) : (
                  null
                )}
              
    
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="pages-left h-100">
              <div className="login-content">
                <h2>{titleName}</h2>

                <p>
                  {" "}
                  <strong>{t('aiPlanTitle', { ns: 'labels' })}</strong> {t('aiPlanDescription', { ns: 'labels' })}
                </p>

                <p>
                  &copy; {new Date().getFullYear()} {t('copyright', { ns: 'labels' })}{" "}
                  <a href="https://www.besmart.it">Be Smart</a> &{" "}
                  <a href="https://qnomos.com">Nomos</a>
                </p>
              </div>
              <div className="login-media text-center">
                <img src="images/login.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}

export { Login_Darm_Screen };
